import { useLocalization } from '@/services/localizationService';
import { deviceType } from '@/core/environment/deviceType';
import { authState } from '@/stores/authStore';
import { useCallback, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { safeLocalStorage } from '@/core/safeLocalStorage/safeLocalStorage';
import { mediaState } from '@/stores/mediaStore';

export const useDownloadNoWatermarkButton = () => {
  const [isTooltipAlreadyShown, setIsTooltipAlreadyShown] = useState(false);
  const auth = useRecoilValue(authState);
  const media = useRecoilValue(mediaState);

  const { data } = useLocalization();

  useEffect(() => {
    setIsTooltipAlreadyShown(
      JSON.parse(safeLocalStorage.getItem('downloadTooltip:shown')!) || false
    );
  }, []);

  useEffect(() => {
    safeLocalStorage.setItem(
      'downloadTooltip:shown',
      JSON.stringify(isTooltipAlreadyShown)
    );
  }, [isTooltipAlreadyShown]);

  const onTooltipDisappear = useCallback(() => {
    setIsTooltipAlreadyShown(true);
  }, []);

  return {
    onTooltipDisappear,
    mediaType: media?.mediaType,
    tooltipText: data.common.imageSavedWithoutWatermark,
    isTooltipVisible:
      auth.isGuestToken &&
      ['mobile', 'tablet'].includes(deviceType()) &&
      (!isTooltipAlreadyShown ||
        process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'),
  };
};
